<script lang="ts" setup>
const { $config } = useNuxtApp();

const years = [2019, 2018];
const selectedYear = ref(2019);

const content = computed(() => contents.value[selectedYear.value as keyof typeof contents.value]);

const contents = ref({
  2018: {
    content: 'Confraternização em 2018 realizada no centro, médiuns e seus familiares.',
    cover: `${$config.public.assetsUrl}/photos/timeline-2018-photo1.jpg`,
  },
  2019: {
    content: `No ano de 2019, iniciamos a transição de centro de Apometria para Terreiro de Umbanda, sendo necessário realizar melhorias nas instalações.

A mesa no centro em forma de ferradura em más condições de uso que foi substituída posteriormente, eram onde os queridos médiuns na época, sentavam a sua volta a fim de darem passagem aos obsessores que por ventura fossem desvinculados aos obsidiados que se submetiam ao trabalho de Apometria.

Na época eram aproximadamente 10 a doze médiuns que se dispunham a trabalharem nas desobsessões.

Era um dirigente de mesa, que nem sempre era o do centro, que coordenava os trabalhos apometricos.
A fundadora do Centro Finada ESTHER BUENO, sempre teve a intenção de trabalhar com a Umbanda, no entanto, por não achar pessoas que ela considerasse de confiança para isso optou pela linha mesclada, Doutrina espirita e Umbanda, tanto é que nos trabalhos de apometria eram entoados cânticos de caboclos e pretos velhos, mostrando assim a força da Umbanda, quando evocada.

Depois dessa pequena reforma partimos para uma reforma mais abrangente com construção de um espaço físico maior.`,
    cover: `${$config.public.assetsUrl}/photos/timeline-2019-photo1.jpg`,
  }
});


function selectYear(year: number) {
  selectedYear.value = year;
}

</script>

<template>
  <section class="mb-40">
    <div>
      <div>
        <h3 class="text-2xl md:text-4xl font-bold w-full mb-8 mt-3 text-center">
          {{ $t('TIMELINE') }}
        </h3>
      </div>
      <div class="tab-list">
        <ul class="flex flex-nowrap mb-24 w-full">
          <li
            class="mr-4"
            v-for="(year, idx) in years"
            :key="year"
          >
            <button :class="{'active': year === selectedYear}" @click="() => selectYear(year)">{{ year }}</button>
          </li>
        </ul>
      </div>
  
      <!-- Tabs -->
       <div class="tab-content flex flex-col 2xl:flex-row gap-28 items-center">
        <!-- Img/Cover -->
        <div>
          <img :src="content.cover" alt="">
        </div>
  
        <!-- Text -->
         <p class="text-justify whitespace-break-spaces">
          {{ content.content }}
         </p>
       </div>
    </div>
  </section>
</template>
<style lang="scss" scoped>
section {
  background-color: #fff;

  > div {
    @apply px-6;
    @apply mx-auto;
    max-width: 1600px;
  }
}

@media (screen(lg)) {
  section {
    > div {
      @apply px-10;
    }
  }
}


ul {
  padding-bottom: 5rem;
  border-bottom: 1px solid #000000;
}

li {
  button {
    transition: all ease 150ms;
    padding: 0.5rem 1rem;
    border-radius: 50px;
    cursor: pointer;

    &.active {
      background-color: var(--theme);
      color: #fff;
    }

    &:hover {
      background-color: var(--theme);
      color: #fff;
      opacity: 0.9;
    }
  }
}

@media (screen(lg)) {
  .tab-content {
    img {
      min-width: 680px;
      max-width: 680px;
    }
  }
}
</style>